import axios from 'axios';

/*
  Take a rater's questionnaire session over as the signed-in examiner (PIN-325),
  resolving to the key saves to it need. The owning examiner gets the same key
  on every call after the first.

  Silent to the error middleware: callers say what went wrong themselves. A
  refusal rejects with the server's reason as the message.
*/
export const takeOverSession = (sessionID, token) =>
  axios
    .post(
      `${process.env.REACT_APP_API_URL}/session/${sessionID}/takeOver`,
      {},
      {
        headers: { 'Content-Type': 'application/json', Authorization: 'Token ' + token },
        _silent: true
      }
    )
    .then(
      (response) => response.data.raterKey,
      (error) => {
        throw new Error(error.response?.data?.message || error.message);
      }
    );
